import React, { useState } from "react";
import generateQuestion from "eight-bit-binary-random-question-generator";
import QuizDisplay from "./components/QuizDisplay";
import QuizButton from "./components/QuizButton";
import Message from "./components/Message";
import QuestionNumberDisplay from "./components/QuestionNumberDisplay";
import StartMenu from "./components/StartMenu";
import "./App.css";

function App() {
  const [start, setStart] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [question, setQuestion] = useState(generateQuestion());
  const [questionsAnswered, setQuestionsAnswered] = useState(1);
  const [message, setMessage] = useState(" ");
  const [numberOfQuestions, setNumberOfQuestions] = useState(20);
  const [scoreSheet, setScoreSheet] = useState([1]);

  const handleNewQuestion = () => {
    setQuestion(generateQuestion());
    setMessage(" ");
    setScoreSheet([...scoreSheet, 1]);
    setQuestionsAnswered(questionsAnswered + 1);
  };

  const handleStartClick = () => {
    setQuestion(generateQuestion());
    setMessage(" ");
    setGameOver(false);
    setScoreSheet([1]);
    setQuestionsAnswered(1);
    setStart(true);
  };
  const handleSeeScore = () => {
    setGameOver(true);
    setStart(false);
  };

  const setMiss = () => {
    setScoreSheet([
      ...scoreSheet.filter((_, i, arr) => i !== arr.length - 1),
      0,
    ]);
  };

  const handleClickAnswer = (val: string | number) => {
    if (val === question.a) {
      setMessage("That's right!");
    } else {
      setMiss();
      setMessage("That's wrong, try again.");
    }
  };

  const getScore = () =>
    ((scoreSheet.reduce((a, b) => a + b) / scoreSheet.length) * 100).toFixed(2);

  const aToF = "abcdef".split("");

  const correct = message === "That's right!";

  return (
    <>
      <header>
        <h2>8-bit Binary Quiz</h2>
      </header>
      {start ? (
        <>
          <div className="App">
            <QuizDisplay>
              <QuestionNumberDisplay
                current={questionsAnswered}
                total={numberOfQuestions}
              />
              <div className="quizDisplayText">
                {correct ? question.a : question.q}
              </div>
              <Message text={message} />
            </QuizDisplay>
            {!correct &&
              Object.values(question.multipleChoice ?? {}).map((e, index) => (
                <QuizButton
                key={index + ":" + e}
                  header={aToF[index]}
                  val={e}
                  handleClick={() => handleClickAnswer(e)}
                  disabled={correct}
                />
              ))}
            {correct && (
              <>
                {numberOfQuestions === questionsAnswered ? (
                  <button onClick={handleSeeScore}>See Score</button>
                ) : (
                  <button onClick={handleNewQuestion}>New Question</button>
                )}
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {gameOver && (
            <QuizDisplay>
              <div className="score">
                <h3>Score: {getScore()}%</h3>
              </div>
            </QuizDisplay>
          )}
          <StartMenu
            handleStartClick={handleStartClick}
            numberOfQuestions={numberOfQuestions}
            setNumberOfQuestions={setNumberOfQuestions}
          />
        </>
      )}
    </>
  );
}

export default App;
